import { element } from 'angular';
import moment from 'moment';

export let DatePickerDirectiveAjs = () => {
  let setScopeValues = (scope, attrs) => {
    scope.format = attrs.format || 'YYYY-MM-DD';
    scope.viewFormat = scope.viewFormat || attrs.viewFormat || 'Do MMMM YYYY';
    scope.locale = attrs.locale || 'fr';
    scope.firstWeekDaySunday = scope.$eval(attrs.firstWeekDaySunday) || false;
    scope.placeholder = attrs.ngPlaceholder || '';
    scope.ngModel = scope.ngModel || scope.$eval(attrs.ngModel) || null;
    scope.idHTML = attrs.htmlid;

    scope.localMax = scope.$eval(attrs.max) || null;
    scope.localMin = scope.$eval(attrs.min) || null;
    scope.ngReadOnly = scope.$eval(attrs.readonly) || false;
  };

  let initVars = scope => {
    scope.calendarOpened = false;
    scope.days = [];
    scope.dayNames = [];
    scope.viewValue = null;
    scope.dateValue = null;
    scope.keys = {};

    moment.locale(scope.locale);
    scope.today = moment();
  };

  return {
    restrict: 'E',
    require: 'ngModel',
    scope: {
      ngModel: '=',
      min: '=?',
      htmlid: '=?',
      max: '=?',
      viewFormat: '=?',
      readOnly: '=?',
    },
    link: (scope, elem, attrs, datePickerCtrl) => {
      setScopeValues(scope, attrs);
      initVars(scope);
      let date = moment();

      elem.on('mousewheel', e => {
        e.preventDefault();
        let selectedScrolledDate = moment(
          scope.ngModel.getDate() + '.' + (scope.ngModel.getMonth() + 1) + '.' + scope.ngModel.getFullYear(),
          'DD.MM.YYYY'
        );
        let oldDay = selectedScrolledDate.date();
        if (e.wheelDelta >= 0) {
          selectedScrolledDate.day(selectedScrolledDate.day() - 1);
          if (selectedScrolledDate.date() > oldDay) {
            scope.prevMonth();
          }
          if (scope.localMin != null && selectedScrolledDate.toDate() < scope.localMin) {
            selectedScrolledDate.set('date', scope.localMin.getDate());
            selectedScrolledDate.set('month', scope.localMin.getMonth());
            selectedScrolledDate.set('year', scope.localMin.getFullYear());
          }
          scope.updateModel(selectedScrolledDate);
        } else {
          selectedScrolledDate.day(selectedScrolledDate.day() + 1);
          if (selectedScrolledDate.date() === 1) {
            scope.nextMonth();
          }
          if (scope.localMax != null && selectedScrolledDate.toDate() > scope.localMax) {
            selectedScrolledDate.set('date', scope.localMax.getDate());
            selectedScrolledDate.set('month', scope.localMax.getMonth());
            selectedScrolledDate.set('year', scope.localMax.getFullYear());
          }
          scope.updateModel(selectedScrolledDate);
        }
        generateCalendar(date);
        scope.$apply();
      });
      elem.on('keyup', e => {
        // reset keys !
        scope.keys[e.keyCode] = e.type === 'keydown';
      });

      elem.on('click', e => {
        let target = element(e.target);
        if (!scope.calendarOpened && target.hasClass('ng-datepicker-input')) {
          scope.showCalendar();
          scope.$apply();
        }
      });

      /**
       * For changes of input from keyboard, when input blur event happens, a validity check is demanded, and changes
       * should be known by model
       */
      scope.blur = () => {
        let modelVal = moment(scope.ngModel).locale(scope.locale).format(scope.viewFormat);
        if (scope.viewValue !== modelVal) {
          let newVal = moment(scope.viewValue, scope.viewFormat);
          if (newVal.isValid() && scope.checkValidity(newVal.toDate())) {
            scope.updateModel(newVal);
          } else {
            scope.viewValue = modelVal;
          }
        }
      };
      elem.on('keydown', e => {
        let key = e.keyCode;
        scope.keys[e.keyCode] = e.type === 'keydown';
        let oldDay;
        switch (key) {
          case 40: // UP
          case 39: // LEFT
            e.preventDefault();
            let selectedPostDate = moment(
              scope.ngModel.getDate() + '.' + (scope.ngModel.getMonth() + 1) + '.' + scope.ngModel.getFullYear(),
              'DD.MM.YYYY'
            );
            oldDay = selectedPostDate.date();
            if (scope.keys[17]) {
              selectedPostDate.month(selectedPostDate.month() + 1);
              scope.nextMonth();
            } else {
              let i = scope.keys[40] ? 7 : 1;

              selectedPostDate.day(selectedPostDate.day() + i);
              if (selectedPostDate.date() < oldDay) {
                scope.nextMonth();
              }
            }
            if (scope.localMax && selectedPostDate.toDate() > scope.localMax) {
              selectedPostDate.set('date', scope.localMax.getDate());
              selectedPostDate.set('month', scope.localMax.getMonth());
              selectedPostDate.set('year', scope.localMax.getFullYear());
            }
            scope.updateModel(selectedPostDate);
            generateCalendar(selectedPostDate);
            scope.$apply();
            break;
          case 38: // DOWN
          case 37: // RIGHT
            e.preventDefault();
            let selectedAntDate = moment(
              scope.ngModel.getDate() + '.' + (scope.ngModel.getMonth() + 1) + '.' + scope.ngModel.getFullYear(),
              'DD.MM.YYYY'
            );
            oldDay = selectedAntDate.date();
            if (scope.keys[17]) {
              selectedAntDate.month(selectedAntDate.month() - 1);
              scope.prevMonth();
            } else {
              let j = scope.keys[38] ? 7 : 1;
              selectedAntDate.day(selectedAntDate.day() - j);
              if (selectedAntDate.date() > oldDay) {
                scope.prevMonth();
              }
            }
            if (scope.localMin && selectedAntDate.toDate() < scope.localMin) {
              selectedAntDate.set('date', scope.localMin.getDate());
              selectedAntDate.set('month', scope.localMin.getMonth());
              selectedAntDate.set('year', scope.localMin.getFullYear());
            }
            scope.updateModel(selectedAntDate);
            generateCalendar(selectedAntDate);
            scope.$apply();
            break;
          case 13: // ENTER
            e.preventDefault();
            scope.toggleCalendar();
            scope.$apply();
            break;
          case 9: // TABULATION
            scope.closeCalendar();
            scope.$apply();
            break;
          case 8: // BACKSPACE
            e.preventDefault();
            scope.$apply();
            break;
          case 27: // ESCAPE
            e.preventDefault();
            scope.closeCalendar();
            scope.$apply();
            break;
          default:
            break;
        }
      });
      scope.$watch('max', d => {
        scope.localMax = d || null;
        if (scope.localMax && scope.localMax < scope.ngModel) {
          scope.ngModel = scope.localMax;
          generateCalendar(moment(d));
        }
      });
      scope.$watch('min', d => {
        scope.localMin = d || null;
        if (scope.localMin && scope.localMin > scope.ngModel) {
          scope.ngModel = scope.localMin;
          generateCalendar(moment(d));
        }
      });

      scope.checkValidity = toBeCompared => {
        if (scope.localMax && toBeCompared > scope.localMax) {
          return false;
        }
        if (scope.localMin && toBeCompared < scope.localMin) {
          return false;
        }
        return true;
      };

      let generateCalendar = _date => {
        let nowDate = parseInt(_date.year().toString() + ('0' + _date.month()).slice(-2), 10);
        if (
          scope.localMin &&
          nowDate < parseInt(scope.localMin.getFullYear().toString() + ('0' + scope.localMin.getMonth()).slice(-2), 10)
        ) {
          _date.set('month', scope.localMin.getMonth());
          _date.set('year', scope.localMin.getFullYear());
        }
        if (
          scope.localMax &&
          nowDate > parseInt(scope.localMax.getFullYear().toString() + ('0' + scope.localMax.getMonth()).slice(-2), 10)
        ) {
          _date.set('month', scope.localMax.getMonth());
          _date.set('year', scope.localMax.getFullYear());
        }

        let lastDayOfMonth = _date.endOf('month').date();
        let month = _date.month();
        let year = _date.year();
        let n = 1;

        let firstWeekDay = scope.firstWeekDaySunday === true ? _date.set('date', 2).day() : _date.set('date', 1).day();
        if (!scope.firstWeekDaySunday && firstWeekDay === 0) {
          firstWeekDay = 7;
        }
        if (firstWeekDay !== 1) {
          n -= firstWeekDay - 1;
        }

        scope.dateValue = _date.format('MMMM YYYY');
        scope.days = [];

        for (let day = n; day <= lastDayOfMonth; day += 1) {
          let minFullDate;
          let maxFullDate;
          if (day > 0) {
            let isMin = false;
            let currentDate = parseInt(year.toString() + ('0' + month).slice(-2) + ('0' + day).slice(-2), 10);
            if (scope.localMin) {
              minFullDate = parseInt(
                scope.localMin.getFullYear().toString() +
                  ('0' + scope.localMin.getMonth()).slice(-2) +
                  ('0' + scope.localMin.getDate()).slice(-2),
                10
              );
              if (currentDate === minFullDate) {
                isMin = true;
              }
            }
            let isMax = false;
            if (scope.localMax) {
              maxFullDate = parseInt(
                scope.localMax.getFullYear().toString() +
                  ('0' + scope.localMax.getMonth()).slice(-2) +
                  ('0' + scope.localMax.getDate()).slice(-2),
                10
              );
              if (currentDate === maxFullDate) {
                // alert("isMAX !!" + currentDate);
                isMax = true;
              }
            }

            let isSelected = false;
            let selectedDate = moment(
              scope.ngModel.getDate() + '.' + (scope.ngModel.getMonth() + 1) + '.' + scope.ngModel.getFullYear(),
              'DD.MM.YYYY'
            );
            if (selectedDate.date() === day && selectedDate.month() === month && selectedDate.year() === year) {
              isSelected = true;
            }
            let isToday = false;
            if (scope.today.date() === day && scope.today.month() === month && scope.today.year() === year) {
              isToday = true;
            }

            let isInScope = false;
            if (
              (scope.localMax == null && scope.localMin == null) ||
              ((minFullDate === undefined || currentDate >= minFullDate) && (maxFullDate === undefined || currentDate <= maxFullDate))
            ) {
              isInScope = true;
            }

            scope.days.push({
              day,
              month: month + 1,
              year,
              enabled: isInScope,
              today: isToday,
              selected: isSelected,
              max: isMax,
              min: isMin,
            });
          } else {
            scope.days.push({
              day: null,
              month: null,
              year: null,
              enabled: false,
              today: false,
              selected: false,
              max: false,
              min: false,
            });
          }
        }
        date = _date;
      };

      let generateDayNames = () => {
        let d = scope.firstWeekDaySunday === true ? moment('2015-06-07') : moment('2015-06-01');
        for (let i = 0; i < 7; i += 1) {
          scope.dayNames.push(d.format('ddd'));
          d.add('1', 'd');
        }
      };

      generateDayNames();

      scope.showCalendar = () => {
        scope.calendarOpened = true;
        generateCalendar(moment(scope.ngModel || new Date()));
      };

      scope.closeCalendar = () => {
        scope.calendarOpened = false;
      };

      scope.toggleCalendar = () => {
        scope.calendarOpened = !scope.calendarOpened;
        if (scope.calendarOpened) {
          generateCalendar(date);
        }
      };

      scope.prevYear = () => {
        if (scope.localMin === null || date.year() - 1 >= scope.localMin.getFullYear()) {
          date.subtract(1, 'y');
          generateCalendar(date);
        }
      };
      scope.nextYear = () => {
        if (scope.localMax === null || date.year() + 1 <= scope.localMax.getFullYear()) {
          date.add(1, 'y');
          generateCalendar(date);
        }
      };
      scope.prevMonth = () => {
        if (scope.localMin === null || !(date.month() === scope.localMin.getMonth() && date.year() === scope.localMin.getFullYear())) {
          date.subtract(1, 'M');
          generateCalendar(date);
        }
      };
      scope.nextMonth = () => {
        if (scope.localMax === null || !(date.month() === scope.localMax.getMonth() && date.year() === scope.localMax.getFullYear())) {
          date.add(1, 'M');
          generateCalendar(date);
        }
      };

      scope.selectDate = (event, d) => {
        event.preventDefault();
        scope.closeCalendar();
        let selectedDate = moment(d.day + '.' + d.month + '.' + d.year, 'DD.MM.YYYY');
        scope.updateModel(selectedDate);
      };

      scope.updateModel = selectedDate => {
        let newDate = moment(scope.ngModel).locale(scope.locale);
        newDate.date(selectedDate.date());
        newDate.month(selectedDate.month());
        newDate.year(selectedDate.year());
        datePickerCtrl.$setViewValue(newDate.toDate());
        scope.viewValue = newDate.format(scope.viewFormat);
      };

      datePickerCtrl.$render = () => {
        let newValue = datePickerCtrl.$viewValue;
        if (newValue !== undefined) {
          scope.viewValue = moment(newValue).locale(scope.locale).format(scope.viewFormat);
          scope.dateValue = newValue;
        }
      };

      // fix to prevent memory leak
      scope.$on('$destroy', () => {
        // remove listener
        elem.off('mousewheel');
        elem.off('click');
        elem.off('keydown');
        elem.off('keyup');
      });
      elem.on('$destroy', () => {
        scope.$destroy();
      });
    },
    template:
      '<div ng-mouseleave="closeCalendar()">' +
      '   <div>' +
      '      <input id="{{idHTML}}" type="text" data-ng-readonly="ngReadOnly" ng-model="viewValue" class="ng-datepicker-input" title="{{ placeholder | i18next}}" placeholder="{{ placeholder | i18next}}" ng-blur="blur()">' +
      '   </div>' +
      '   <div class="ng-datepicker" ng-show="calendarOpened">' +
      '     <div class="controls">' +
      '       <div class="left">' +
      '         <div class="prevYear" ng-click="prevYear()"></div>' +
      '         <div class="prevMonth" ng-click="prevMonth()"></div>' +
      '       </div>' +
      '       <span class="date" ng-bind="dateValue"></span>' +
      '       <div class="right">' +
      '         <div class="nextMonth" ng-click="nextMonth()"></div>' +
      '         <div class="nextYear" ng-click="nextYear()"></div>' +
      '       </div>' +
      '     </div>' +
      '     <div class="day-names">' +
      '       <span ng-repeat="dn in dayNames">' +
      '         <span>{{ dn }}</span>' +
      '       </span>' +
      '     </div>' +
      '     <div class="calendar">' +
      '       <span ng-repeat="d in days">' +
      '         <span class="day" ng-click="selectDate($event, d)" ng-class="{disabled: !d.enabled, today: d.today, selected:d.selected, max:d.max, min:d.min}">{{ d.day }}</span>' +
      '       </span>' +
      '     </div>' +
      '   </div>' +
      '</div>',
  };
};

export default 'cngDatepicker';
